/* ============================================================
   NEXORA · LA CONSOLA — buscador de 4 carriles para Shopify
   Vehículo · Número OEM · VIN · Código de falla

   A diferencia de la maqueta, aquí el catálogo, los precios y el
   carrito son los REALES de la tienda: los productos llegan desde
   Liquid y el carrito habla con /cart/*.js. El checkout es el nativo.
   ============================================================ */

const NX = (() => {
  const el = document.getElementById('nexora-datos');
  try { return JSON.parse(el.textContent); } catch { return { wa: '', productos: [], rutas: {} }; }
})();

const WA = NX.wa;
const RUTAS = NX.rutas || {};

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

/* ---------- CLASIFICACIÓN AUTOMÁTICA ----------
   El tipo de pieza y las marcas compatibles se deducen del título y las
   etiquetas del producto. Así, cuando cargues productos nuevos en Shopify,
   el buscador los reconoce sin tocar código. */
const NOMBRE_TIPO = {
  O2: 'Sensor de oxígeno', MAF: 'Sensor MAF', CMP: 'Sensor CMP (árbol de levas)',
  CKP: 'Sensor CKP (cigüeñal)', ECT: 'Sensor ECT (temperatura)',
  Knock: 'Sensor de detonación', VVT: 'Solenoide VVT', 'Módulo': 'Módulo de potencia',
  Otro: 'Otra electrónica',
};

const MARCAS = [
  { id: 'ford', n: 'Ford', lineas: 'Fiesta · Fusion · Edge · Escape · Transit', pistas: ['FORD', 'FIESTA', 'FUSION', 'EDGE', 'ESCAPE', 'TRANSIT', 'EXPLORER', 'RANGER'] },
  { id: 'chevrolet', n: 'Chevrolet', lineas: 'Cruze · Sonic · Trax · Volt', pistas: ['CHEVROLET', 'CHEVY', 'CRUZE', 'SONIC', 'TRAX', 'VOLT', 'ACDELCO', 'GM '] },
  { id: 'mazda', n: 'Mazda', lineas: 'Mazda 2 · 3 · 5 · 6 · CX-7', pistas: ['MAZDA', 'CX-7', 'CX7'] },
  { id: 'honda', n: 'Honda', lineas: 'Civic · Accord · CR-V', pistas: ['HONDA', 'CIVIC', 'ACCORD', 'CR-V', 'CRV'] },
  { id: 'toyota', n: 'Toyota', lineas: 'Corolla · Matrix · Tacoma · Hilux · 4Runner', pistas: ['TOYOTA', 'COROLLA', 'MATRIX', 'TACOMA', 'HILUX', '4RUNNER'] },
  { id: 'hyundai', n: 'Hyundai', lineas: 'Tucson · Sonata', pistas: ['HYUNDAI', 'TUCSON', 'SONATA'] },
  { id: 'kia', n: 'Kia', lineas: 'Sportage', pistas: ['KIA', 'SPORTAGE'] },
  { id: 'suzuki', n: 'Suzuki', lineas: 'Grand Vitara', pistas: ['SUZUKI', 'VITARA'] },
  { id: 'dodge', n: 'Dodge / RAM', lineas: 'Ram 1500 · Caravan', pistas: ['DODGE', 'RAM ', 'CARAVAN', 'MOPAR', 'TIPM'] },
  { id: 'jeep', n: 'Jeep', lineas: 'Wrangler · Cherokee · Compass', pistas: ['JEEP', 'WRANGLER', 'CHEROKEE', 'COMPASS'] },
  { id: 'nissan', n: 'Nissan', lineas: 'Sentra · Frontier · X-Trail', pistas: ['NISSAN', 'SENTRA', 'FRONTIER', 'X-TRAIL'] },
  { id: 'otra', n: 'Otra marca', lineas: 'La conseguimos igual', pistas: [] },
];

const PISTAS_TIPO = [
  ['O2', ['O2', 'OXIGENO', 'OXÍGENO', 'OXYGEN', 'AFR', 'LAMBDA']],
  ['MAF', ['MAF', 'MASS AIR', 'CAUDAL']],
  ['CMP', ['CMP', 'CAMSHAFT', 'ARBOL DE LEVAS', 'ÁRBOL DE LEVAS']],
  ['CKP', ['CKP', 'CRANKSHAFT', 'CIGUENAL', 'CIGÜEÑAL']],
  ['ECT', ['ECT', 'COOLANT', 'REFRIGERANTE', 'TEMPERATURA']],
  ['Knock', ['KNOCK', 'DETONACION', 'DETONACIÓN']],
  ['VVT', ['VVT', 'VTC', 'SOLENOID', 'SOLENOIDE']],
  ['Módulo', ['TIPM', 'MODULE', 'MODULO', 'MÓDULO', 'ECU', 'PCM', 'BCM', 'TCM', 'COMPUTAD']],
];

const sinTildes = (t) => String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();

function clasificar(p) {
  const heno = sinTildes([p.titulo, p.tipoShopify, p.marca, (p.etiquetas || []).join(' ')].join(' '));
  let tipo = 'Otro';
  for (const [t, pistas] of PISTAS_TIPO) {
    if (pistas.some((k) => heno.includes(sinTildes(k)))) { tipo = t; break; }
  }
  const makes = MARCAS.filter((m) => m.pistas.some((k) => heno.includes(sinTildes(k)))).map((m) => m.id);
  if (heno.includes('UNIVERSAL')) makes.push('universal');
  return { ...p, tipo, makes };
}

const CATALOGO = (NX.productos || []).map(clasificar);

const DTC = {
  P0135: { d: 'Circuito del calentador · sensor O2 banco 1 sensor 1', t: 'O2' },
  P0141: { d: 'Circuito del calentador · sensor O2 banco 1 sensor 2', t: 'O2' },
  P0131: { d: 'Voltaje bajo · sensor O2 banco 1 sensor 1', t: 'O2' },
  P0171: { d: 'Mezcla pobre · banco 1', t: 'O2' },
  P0172: { d: 'Mezcla rica · banco 1', t: 'O2' },
  P0101: { d: 'Rango/rendimiento del sensor MAF', t: 'MAF' },
  P0102: { d: 'Señal baja del sensor MAF', t: 'MAF' },
  P0335: { d: 'Circuito del sensor de cigüeñal (CKP)', t: 'CKP' },
  P0340: { d: 'Circuito del sensor de árbol de levas (CMP)', t: 'CMP' },
  P0325: { d: 'Circuito del sensor de detonación (knock)', t: 'Knock' },
  P0128: { d: 'Termostato / temperatura de refrigerante', t: 'ECT' },
  P0011: { d: 'Posición del árbol de levas · avance (VVT)', t: 'VVT' },
};

const S = { carril: 'vehiculo', marca: null, pieza: '', oem: '', vin: '', vinDec: '', dtc: '' };

const ref = () => {
  const d = new Date(), p = (n) => String(n).padStart(2, '0');
  return 'NX-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' +
    Math.random().toString(36).slice(2, 6).toUpperCase();
};

/* ---------- DETECCIÓN DE CARRIL ---------- */
function detectar(v) {
  const t = v.trim().toUpperCase();
  if (!t) return null;
  if (/^[A-HJ-NPR-Z0-9]{17}$/.test(t)) return { carril: 'vin', etq: 'VIN DETECTADO' };
  if (/^[PBCU][0-9]{4}$/.test(t)) return { carril: 'falla', etq: 'CÓDIGO DE FALLA' };
  if (/^02(58|32|80)[0-9]{6}$/.test(t.replace(/\s/g, ''))) return { carril: 'oem', etq: 'N° DE PARTE · BOSCH' };
  if (/^(234|197|250|350|245)-?[0-9]{3,5}$/.test(t)) return { carril: 'oem', etq: 'N° DE PARTE · DENSO/WALKER' };
  if (/^(PC|MAS|MA)[0-9]{3,4}$/.test(t)) return { carril: 'oem', etq: 'N° DE PARTE · SMP' };
  if (/^2[0-9]{4}$/.test(t)) return { carril: 'oem', etq: 'N° DE PARTE · NTK' };
  if (/^1[0-9]{7}$/.test(t)) return { carril: 'oem', etq: 'N° DE PARTE · GM / ACDELCO' };
  if (/^[0-9]{4,}[-A-Z0-9]*$/.test(t)) return { carril: 'oem', etq: 'N° DE PARTE' };
  return { carril: 'vehiculo', etq: 'VEHÍCULO' };
}

/* ---------- BÚSQUEDA ---------- */
const norm = (s) => String(s).toUpperCase().replace(/[^A-Z0-9]/g, '');
const JERGA = {
  COMPUTADOR: 'MODULO', COMPUTADORA: 'MODULO', CEREBRO: 'MODULO', MEMORIA: 'MODULO',
  CIGUENAL: 'CKP', LEVAS: 'CMP', OXIGENO: 'O2', SONDA: 'O2', LAMBDA: 'O2',
  CAUDALIMETRO: 'MAF', PICADO: 'KNOCK', DETONACION: 'KNOCK',
};

function buscarOEM(q) {
  const n = norm(q); if (n.length < 3) return [];
  return CATALOGO.filter((p) => norm(p.oem).includes(n) || norm(p.sku).includes(n) || norm(p.titulo).includes(n));
}
function buscarVehiculo(makeId) {
  return CATALOGO.filter((p) => p.makes.includes(makeId) || p.makes.includes('universal'));
}
function buscarPorTipo(tipo, makeId) {
  return CATALOGO.filter((p) => p.tipo === tipo && (!makeId || p.makes.includes(makeId) || p.makes.includes('universal')));
}
function buscarTexto(q) {
  const pal = sinTildes(q).split(/[^A-Z0-9]+/).filter((w) => w.length > 2).map((w) => JERGA[w] || w);
  if (!pal.length) return [];
  return CATALOGO.filter((p) => {
    const heno = sinTildes([p.titulo, NOMBRE_TIPO[p.tipo], p.marca, p.tipo, p.oem,
      p.makes.map((id) => (MARCAS.find((m) => m.id === id) || {}).n || '').join(' ')].join(' '));
    return pal.every((w) => heno.includes(w));
  });
}

/* ---------- MENSAJES DE WHATSAPP ---------- */
function waLink(msg) { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg); }
const nombreMarca = (id) => (MARCAS.find((x) => x.id === id) || {}).n || '';

function msgVehiculo() {
  return ['*NEXORA · Solicitud de repuesto*', 'Ref: ' + ref(), '',
    '*Vehículo:* ' + nombreMarca(S.marca),
    '*Pieza que necesito:* ' + (S.pieza || 'No sé cómo se llama — adjunto foto en este chat'),
    '', 'Origen: nexoraoem.com · Buscador por vehículo'].join('\n');
}
function msgOEM(q) {
  return ['*NEXORA · Solicitud por número de parte*', 'Ref: ' + ref(), '',
    '*Número OEM:* ' + q, '*Cantidad:* 1',
    '', 'Origen: nexoraoem.com · Buscador por número OEM'].join('\n');
}
function msgVIN() {
  return ['*NEXORA · Solicitud por VIN*', 'Ref: ' + ref(), '',
    '*VIN:* ' + S.vin,
    '*Decodificado:* ' + (S.vinDec || 'No disponible — por confirmar'),
    '*Pieza que necesito:* ' + (S.pieza || 'Por definir con el asesor'),
    '', 'Origen: nexoraoem.com · Buscador por VIN'].join('\n');
}
function msgDTC(code) {
  const d = DTC[code];
  return ['*NEXORA · Diagnóstico y cotización*', 'Ref: ' + ref(), '',
    '*Código de falla:* ' + code,
    d ? '*Significa:* ' + d.d : '',
    d ? '*Pieza probable:* ' + NOMBRE_TIPO[d.t] : '',
    S.marca ? '*Vehículo:* ' + nombreMarca(S.marca) : '',
    '', 'Origen: nexoraoem.com · Buscador por código de falla'].filter(Boolean).join('\n');
}
function msgTextoLibre(q) {
  return ['*NEXORA · Solicitud de repuesto*', 'Ref: ' + ref(), '',
    '*Lo que busco:* ' + q,
    S.marca ? '*Marca:* ' + nombreMarca(S.marca) : '',
    '', 'No lo encontré en la página. ¿Me confirman si lo consiguen, precio y tiempo?',
    '', 'Origen: nexoraoem.com · Buscador'].filter(Boolean).join('\n');
}
function msgProducto(p) {
  return ['*NEXORA · Consulta de producto*', 'Ref: ' + ref(), '',
    '*Producto:* ' + p.titulo, '*N° de parte:* ' + p.oem, '*SKU:* ' + p.sku,
    '', '¿Me confirman compatibilidad y disponibilidad?',
    '', 'Origen: nexoraoem.com'].join('\n');
}

/* ---------- RESULTADOS ----------
   Cuando la pieza no está publicada NO se pierde el cliente: se abre
   WhatsApp de inmediato con todo lo que ya escribió. */
let ultimoSalto = '';
function saltarAWhatsApp(mensaje) {
  if (ultimoSalto === mensaje) return false;
  ultimoSalto = mensaje;
  const v = window.open(waLink(mensaje), '_blank');
  if (v) { try { v.opener = null; } catch (e) { /* nada */ } }
  return !!v;
}

function pintarResultados(lista, contexto) {
  const box = $('#resultados');
  if (!box) return;
  if (!lista.length) {
    const abierto = saltarAWhatsApp(contexto);
    box.innerHTML =
      '<div class="sin-resultado">' +
      '<span class="micro">No está en el catálogo publicado</span>' +
      '<p class="mt-s" style="font-size:17px;font-weight:600">Eso no significa que no lo consigamos.</p>' +
      '<p class="mt-s" style="font-size:15px;color:var(--nx-texto-tenue)">Lo importamos por pedido desde Estados Unidos. ' +
      (abierto ? 'Te acabamos de abrir WhatsApp con tus datos ya escritos — solo dale enviar.'
               : 'Escríbenos y te confirmamos precio, compatibilidad y tiempo de entrega.') + '</p>' +
      '<a class="btn btn-wa btn-bloque mt-m" href="' + waLink(contexto) + '" target="_blank" rel="noopener">' +
      (abierto ? 'Abrir WhatsApp de nuevo' : 'Pedir cotización por WhatsApp') + '</a>' +
      '<p class="micro mt-s">Respondemos en horario laboral · Medellín</p></div>';
    return;
  }
  box.innerHTML =
    '<div class="micro" style="margin-bottom:10px">' + lista.length + ' resultado' + (lista.length > 1 ? 's' : '') + ' en existencia</div>' +
    lista.slice(0, 8).map((p) =>
      '<a class="res-item" href="' + p.url + '">' +
      '<img src="' + p.img + '" srcset="' + p.img + ' 1x, ' + (p.img2x || p.img) + ' 2x" ' +
      'alt="" loading="lazy" decoding="async" width="56" height="56">' +
      '<span class="res-info"><span class="res-titulo">' + p.titulo + '</span>' +
      '<span class="res-meta">' + p.marca + (p.oem ? ' · OEM ' + p.oem : '') + '</span></span>' +
      '<span class="res-precio">' + p.precioFmt + '</span></a>').join('') +
    (lista.length > 8 ? '<div class="micro mt-s">+ ' + (lista.length - 8) + ' más — escríbenos y te los pasamos todos</div>' : '') +
    '<a class="btn btn-wa btn-bloque mt-m" href="' + waLink(contexto) + '" target="_blank" rel="noopener">' +
    'Confirmar compatibilidad por WhatsApp</a>';
}

/* ---------- CONSOLA ---------- */
function irACarril(c) {
  S.carril = c;
  const tabs = $$('.carril-tab'), pista = $('.carriles');
  tabs.forEach((t, i) => {
    t.setAttribute('aria-selected', String(t.dataset.carril === c));
    if (t.dataset.carril === c && pista) pista.style.setProperty('--carril-activo', i);
  });
  $$('.panel-carril').forEach((p) => p.classList.toggle('oculto', p.dataset.carril !== c));
  const r = $('#resultados'); if (r) r.innerHTML = '';
}

function correrOEM() {
  const q = $('#oem-input').value.trim(); if (!q) return;
  S.oem = q;
  pintarResultados(buscarOEM(q), msgOEM(q));
}

async function correrVIN() {
  const v = $('#vin-input').value.trim().toUpperCase();
  const est = $('#vin-estado');
  if (v.length !== 17) { est.textContent = 'El VIN debe tener 17 caracteres.'; return; }
  S.vin = v; est.textContent = 'Consultando la base de datos de EE. UU.…';
  try {
    const ctrl = new AbortController(); setTimeout(() => ctrl.abort(), 6000);
    const res = await fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + v + '?format=json', { signal: ctrl.signal });
    const j = await res.json(); const row = (j.Results || [])[0] || {};
    const partes = [row.Make, row.Model, row.ModelYear, row.DisplacementL ? row.DisplacementL + 'L' : '', row.FuelTypePrimary].filter(Boolean);
    if (!row.Make) { est.textContent = 'No pudimos identificar ese VIN. Escríbenos y lo verificamos a mano.'; S.vinDec = ''; }
    else { S.vinDec = partes.join(' · '); est.innerHTML = '<span class="veredicto v-ok">✓ ' + S.vinDec + '</span>'; }
  } catch (e) {
    est.textContent = 'No se pudo consultar en este momento — igual podemos ayudarte por WhatsApp.';
  }
  const makeId = (S.vinDec.split(' · ')[0] || '').toLowerCase();
  const m = MARCAS.find((x) => makeId.includes(x.id));
  pintarResultados(m ? buscarVehiculo(m.id) : [], msgVIN());
}

function correrDTC(code) {
  const est = $('#dtc-estado');
  if (!/^[PBCU][0-9]{4}$/.test(code)) { est.textContent = 'Escribe un código como P0135.'; return; }
  S.dtc = code; const d = DTC[code];
  if (!d) {
    est.innerHTML = '<span class="veredicto v-alerta">Código ' + code + ' — lo revisamos contigo</span>';
    pintarResultados([], msgDTC(code)); return;
  }
  est.innerHTML = '<span class="veredicto v-ok">' + code + ' · ' + d.d + '</span>' +
    '<p class="mt-s" style="font-size:15px;color:var(--nx-texto-tenue)">Pieza probable: <b>' + NOMBRE_TIPO[d.t] + '</b></p>';
  pintarResultados(buscarPorTipo(d.t, S.marca), msgDTC(code));
}

function initConsola() {
  const omni = $('#omni'), det = $('#detector');
  if (omni) {
    if (window.matchMedia('(max-width: 767px)').matches) omni.placeholder = 'VIN, N° de parte o P0135…';
    omni.addEventListener('input', () => {
      const d = detectar(omni.value);
      if (d) { det.textContent = d.etq; det.classList.add('on'); } else det.classList.remove('on');
    });
    const lanzar = () => {
      const v = omni.value.trim(); const d = detectar(v); if (!d) return;
      irACarril(d.carril);
      if (d.carril === 'oem') { $('#oem-input').value = v; correrOEM(); }
      if (d.carril === 'vin') { $('#vin-input').value = v; correrVIN(); }
      if (d.carril === 'falla') { correrDTC(v.toUpperCase()); }
      if (d.carril === 'vehiculo') { pintarResultados(buscarInteligente(v), msgTextoLibre(v)); }
      $('#consola').scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    omni.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      lanzar();
    });
    const btnBuscar = $('#omni-btn');
    if (btnBuscar) btnBuscar.addEventListener('click', lanzar);
  }

  $$('.carril-tab').forEach((t) => t.addEventListener('click', () => irACarril(t.dataset.carril)));

  const cm = $('#chips-marca');
  if (cm) {
    cm.innerHTML = MARCAS.map((m) => '<button class="chip" data-marca="' + m.id + '" aria-pressed="false">' + m.n + '</button>').join('');
    $$('#chips-marca .chip').forEach((c) => c.addEventListener('click', () => {
      $$('#chips-marca .chip').forEach((x) => x.setAttribute('aria-pressed', 'false'));
      c.setAttribute('aria-pressed', 'true');
      S.marca = c.dataset.marca;
      $('#paso-pieza').classList.remove('oculto');
      const tipos = [...new Set(buscarVehiculo(S.marca).map((p) => p.tipo))];
      $('#chips-pieza').innerHTML =
        (tipos.length ? tipos : Object.keys(NOMBRE_TIPO)).map((t) =>
          '<button class="chip chip-s" data-tipo="' + t + '" aria-pressed="false">' + NOMBRE_TIPO[t] + '</button>').join('') +
        '<button class="chip chip-s" data-tipo="otro" aria-pressed="false">Otra pieza</button>';
      $$('#chips-pieza .chip').forEach((pc) => pc.addEventListener('click', () => {
        $$('#chips-pieza .chip').forEach((x) => x.setAttribute('aria-pressed', 'false'));
        pc.setAttribute('aria-pressed', 'true');
        S.pieza = pc.dataset.tipo === 'otro' ? '' : NOMBRE_TIPO[pc.dataset.tipo];
        pintarResultados(pc.dataset.tipo === 'otro' ? [] : buscarPorTipo(pc.dataset.tipo, S.marca), msgVehiculo());
      }));
      pintarResultados(buscarVehiculo(S.marca), msgVehiculo());
    }));
  }

  const ob = $('#oem-btn'); if (ob) ob.addEventListener('click', correrOEM);
  const oi = $('#oem-input'); if (oi) oi.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); correrOEM(); } });

  const vb = $('#vin-btn'); if (vb) vb.addEventListener('click', correrVIN);
  const vi = $('#vin-input');
  if (vi) vi.addEventListener('input', (e) => {
    const v = e.target.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 17);
    e.target.value = v; $('#vin-cuenta').textContent = v.length + '/17';
  });

  const di = $('#dtc-input');
  if (di) di.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); correrDTC(e.target.value.toUpperCase().trim()); } });
  const db = $('#dtc-btn'); if (db) db.addEventListener('click', () => correrDTC($('#dtc-input').value.toUpperCase().trim()));

  const mz = $('#matriz-cobertura');
  if (mz) {
    mz.innerHTML = MARCAS.filter((m) => m.id !== 'otra').map((m) => {
      const n = CATALOGO.filter((p) => p.makes.includes(m.id)).length;
      return '<button class="matriz-celda" data-marca="' + m.id + '">' +
        '<span class="marca">' + m.n + '</span><span class="lineas">' + m.lineas + '</span>' +
        '<span class="n">' + (n > 0 ? n + ' en existencia' : 'por pedido') + '</span></button>';
    }).join('');
    $$('#matriz-cobertura .matriz-celda').forEach((c) => c.addEventListener('click', () => {
      irACarril('vehiculo');
      const chip = $('#chips-marca .chip[data-marca="' + c.dataset.marca + '"]');
      if (chip) chip.click();
      $('#consola').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
  }

  const dg = $('#dtc-grid');
  if (dg) {
    dg.innerHTML = Object.keys(DTC).map((c) =>
      '<button class="dtc-chip" data-dtc="' + c + '"><span class="dtc-code">' + c + '</span>' +
      '<span class="dtc-desc">' + DTC[c].d + '</span></button>').join('');
    $$('#dtc-grid .dtc-chip').forEach((b) => b.addEventListener('click', () => {
      irACarril('falla'); $('#dtc-input').value = b.dataset.dtc; correrDTC(b.dataset.dtc);
      $('#consola').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
  }
}

/* ---------- CARRITO REAL DE SHOPIFY ---------- */
async function leerCarrito() {
  const r = await fetch(RUTAS.cart + '.js', { headers: { Accept: 'application/json' } });
  return r.json();
}
async function agregarAlCarrito(idVariante, cantidad) {
  const r = await fetch(RUTAS.cart_add + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: idVariante, quantity: cantidad }] }),
  });
  if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'No se pudo agregar'); }
  return r.json();
}
async function cambiarLinea(clave, cantidad) {
  const r = await fetch(RUTAS.cart_change + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: clave, quantity: cantidad }),
  });
  return r.json();
}

function pintarCuenta(n) {
  const c = $('#cuenta-carrito'); if (!c) return;
  const previa = c.textContent;
  c.textContent = n; c.hidden = n === 0;
  if (previa !== String(n) && n > 0) { c.classList.remove('cambio'); void c.offsetWidth; c.classList.add('cambio'); }
}

/* ---------- Paneles ---------- */
let panelActivo = null, focoPrevio = null;
function abrirPanel(id) {
  cerrarPanel(true);
  focoPrevio = document.activeElement;
  const p = $('#' + id), v = $('#velo');
  v.hidden = false; requestAnimationFrame(() => v.classList.add('visible'));
  p.classList.add('abierto'); p.setAttribute('aria-hidden', 'false');
  panelActivo = p;
  document.body.style.overflow = 'hidden';
  const cerrar = p.querySelector('.panel-cerrar'); if (cerrar) cerrar.focus();
}
function cerrarPanel(silencioso) {
  if (!panelActivo) return;
  panelActivo.classList.remove('abierto');
  panelActivo.setAttribute('aria-hidden', 'true');
  panelActivo = null;
  const v = $('#velo');
  v.classList.remove('visible');
  setTimeout(() => { if (!panelActivo) v.hidden = true; }, 250);
  document.body.style.overflow = '';
  if (!silencioso && focoPrevio) focoPrevio.focus();
}

/* ---------- Ficha de producto ---------- */
let ppSku = null, ppCant = 1;
function abrirProducto(sku) {
  const p = CATALOGO.find((x) => x.sku === sku); if (!p) return;
  ppSku = sku; ppCant = 1;
  const compat = MARCAS.filter((m) => p.makes.includes(m.id)).map((m) => m.n).join(' · ') || 'Universal';
  $('#pp-tipo').textContent = NOMBRE_TIPO[p.tipo] + (p.marca ? ' · ' + p.marca : '');
  $('#pp-cuerpo').innerHTML =
    '<div class="pp-img"><img src="' + (p.imgGrande || p.img) + '" ' +
    'srcset="' + (p.imgGrande || p.img) + ' 800w, ' + (p.imgGrande2x || p.imgGrande || p.img) + ' 1400w" ' +
    'sizes="(min-width: 440px) 400px, 92vw" alt="' + p.titulo + '" decoding="async"></div>' +
    '<h3 class="pp-titulo" id="pp-titulo">' + p.titulo + '</h3>' +
    '<dl class="pp-datos">' +
    (p.oem ? '<dt>N° de parte</dt><dd>' + p.oem + '</dd>' : '') +
    (p.sku ? '<dt>SKU</dt><dd>' + p.sku + '</dd>' : '') +
    (p.marca ? '<dt>Marca</dt><dd>' + p.marca + '</dd>' : '') +
    '<dt>Compatible</dt><dd>' + compat + '</dd></dl>' +
    '<div class="pp-precio">' + p.precioFmt + '</div>' +
    '<p class="pp-nota">Producto OEM nuevo · 6 meses de garantía · entrega 7–13 días hábiles</p>' +
    (p.disponible ? '<div class="veredicto v-ok mt-m">● En existencia</div>'
                  : '<div class="veredicto v-alerta mt-m">● Por pedido — lo traemos</div>') +
    '<div class="acciones">' +
    '<div class="cantidad">' +
    '<button type="button" data-cant="-1" aria-label="Quitar uno">−</button>' +
    '<span id="pp-cant">1</span>' +
    '<button type="button" data-cant="1" aria-label="Agregar uno">+</button></div>' +
    (p.disponible
      ? '<button class="btn btn-primario" id="pp-agregar" style="flex:1"><span class="etiqueta">Agregar al carrito</span><span class="cargando">Agregando…</span></button>'
      : '') +
    '</div>' +
    '<div id="pp-error"></div>' +
    '<a class="btn btn-wa btn-bloque mt-s" href="' + waLink(msgProducto(p)) + '" target="_blank" rel="noopener">' +
    'Confirmar compatibilidad por WhatsApp</a>' +
    '<a class="btn btn-linea btn-bloque mt-s" href="' + p.url + '">Ver la ficha completa</a>' +
    '<p class="micro" style="margin-top:16px;line-height:1.7">¿No estás seguro de que es el tuyo? ' +
    'Escríbenos el VIN y lo verificamos antes de que pagues.</p>';

  $$('#pp-cuerpo [data-cant]').forEach((b) => b.addEventListener('click', () => {
    ppCant = Math.max(1, Math.min(20, ppCant + Number(b.dataset.cant)));
    $('#pp-cant').textContent = ppCant;
  }));
  const bt = $('#pp-agregar');
  if (bt) bt.addEventListener('click', async () => {
    bt.setAttribute('aria-busy', 'true');
    try {
      await agregarAlCarrito(p.vid, ppCant);
      await abrirCarrito();
    } catch (err) {
      $('#pp-error').innerHTML = '<div class="nx-error">' + err.message + '</div>';
    } finally {
      bt.removeAttribute('aria-busy');
    }
  });
  abrirPanel('panel-producto');
}

/* ---------- Carrito ---------- */
function msgCarrito(carro) {
  return ['*NEXORA · Pedido desde el carrito*', 'Ref: ' + ref(), ''].concat(
    carro.items.map((l) => '• ' + l.quantity + ' × ' + l.product_title),
    ['', '*Subtotal:* ' + (carro.total_price / 100).toLocaleString('es-CO'),
      '', 'Quiero confirmar disponibilidad y forma de pago.',
      'Origen: nexoraoem.com · Carrito']).join('\n');
}

/* Formatea igual que Shopify: toma el formato de moneda de la tienda
   (que puede ser $ {{amount}}, {{amount_with_comma_separator}} COP, etc.)
   para que lo que se lee en el carrito sea lo mismo que cobra el checkout. */
function fmtDinero(centavos) {
  const formato = NX.formato || '${{amount}}';
  const hueco = /\{\{\s*(\w+)\s*\}\}/;
  const m = formato.match(hueco);
  if (!m) return formato;

  function conSeparadores(n, decimales, miles, decimal) {
    if (isNaN(n) || n === null) return '0';
    const fijo = (n / 100).toFixed(decimales);
    const partes = fijo.split('.');
    const enteros = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
    return enteros + (partes[1] ? decimal + partes[1] : '');
  }

  let valor;
  switch (m[1]) {
    case 'amount_no_decimals':                        valor = conSeparadores(centavos, 0, ',', '.'); break;
    case 'amount_with_comma_separator':               valor = conSeparadores(centavos, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator':   valor = conSeparadores(centavos, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator':          valor = conSeparadores(centavos, 2, "'", '.'); break;
    default:                                          valor = conSeparadores(centavos, 2, ',', '.');
  }
  return formato.replace(hueco, valor);
}

async function pintarCarrito() {
  const cuerpo = $('#pc-cuerpo'), pie = $('#pc-pie');
  const carro = await leerCarrito();
  pintarCuenta(carro.item_count);

  if (!carro.items.length) {
    cuerpo.innerHTML =
      '<div class="carrito-vacio"><span class="micro">Carrito vacío</span>' +
      '<p class="mt-s" style="font-size:17px;font-weight:600">Todavía no has agregado nada.</p>' +
      '<p class="mt-s" style="font-size:15px;color:var(--nx-texto-tenue)">Busca tu repuesto por vehículo, número de parte o VIN.</p>' +
      '<button class="btn btn-primario mt-m" id="pc-buscar">Buscar mi repuesto</button></div>';
    pie.innerHTML = '';
    const b = $('#pc-buscar');
    if (b) b.addEventListener('click', () => {
      cerrarPanel();
      const c = $('#consola');
      if (c) c.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else window.location = RUTAS.root;
    });
    return;
  }

  cuerpo.innerHTML = carro.items.map((l) =>
    '<div class="linea">' +
    '<img src="' + (l.image || '') + '" alt="" loading="lazy" decoding="async" width="62" height="62">' +
    '<div class="linea-info">' +
    '<div class="linea-t">' + l.product_title + '</div>' +
    '<div class="linea-m">' + (l.sku || '') + '</div>' +
    '<div class="linea-fila">' +
    '<div class="cantidad" style="height:34px">' +
    '<button type="button" data-clave="' + l.key + '" data-delta="-1" aria-label="Quitar uno">−</button>' +
    '<span>' + l.quantity + '</span>' +
    '<button type="button" data-clave="' + l.key + '" data-delta="1" aria-label="Agregar uno">+</button></div>' +
    '<span class="linea-precio">' + fmtDinero(l.line_price) + '</span></div>' +
    '<button class="quitar mt-s" data-quitar="' + l.key + '">Quitar</button>' +
    '</div></div>').join('');

  $$('#pc-cuerpo [data-delta]').forEach((b) => b.addEventListener('click', async () => {
    const linea = carro.items.find((x) => x.key === b.dataset.clave);
    await cambiarLinea(b.dataset.clave, linea.quantity + Number(b.dataset.delta));
    pintarCarrito();
  }));
  $$('#pc-cuerpo [data-quitar]').forEach((b) => b.addEventListener('click', async () => {
    await cambiarLinea(b.dataset.quitar, 0);
    pintarCarrito();
  }));

  pie.innerHTML =
    '<div class="total"><span class="micro">Subtotal</span><span class="n">' + fmtDinero(carro.total_price) + '</span></div>' +
    '<p class="micro" style="text-transform:none;letter-spacing:0;color:var(--nx-texto-tenue);margin-bottom:14px">' +
    'Envío e impuestos se calculan en el pago.</p>' +
    '<a class="btn btn-primario btn-bloque" href="' + RUTAS.checkout + '">Finalizar compra</a>' +
    '<a class="btn btn-wa btn-bloque mt-s" href="' + waLink(msgCarrito(carro)) + '" target="_blank" rel="noopener">' +
    'Cerrar el pedido por WhatsApp</a>';
}
async function abrirCarrito() { await pintarCarrito(); abrirPanel('panel-carrito'); }



/* ============================================================
   BUSCADOR CON INTELIGENCIA
   Cuatro capas encima de la búsqueda literal:
   1. Tolera errores de dedo  ("sensro" encuentra "sensor")
   2. Entiende el año         ("fiesta 2014" filtra por año)
   3. Puntúa por relevancia   (coincidir en la referencia pesa más que en el título)
   4. Sugiere mientras escribes, sin ir al servidor
   ============================================================ */

/* Distancia de edición acotada: dice si dos palabras se parecen lo suficiente. */
function pareceA(a, b, tope) {
  if (a === b) return true;
  if (Math.abs(a.length - b.length) > tope) return false;
  const m = a.length, n = b.length;
  // Damerau: cambiar dos letras de sitio ("sensro" por "sensor") es UN error,
  // no dos. Es el error de tecleo más común y hay que perdonarlo.
  const d = Array.from({ length: m + 1 }, (_, i) => [i, ...Array(n).fill(0)]);
  for (let j = 0; j <= n; j++) d[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const c = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    if (Math.min(...d[i]) > tope) return false;
  }
  return d[m][n] <= tope;
}

/* Un error por cada 4 letras, y nunca en palabras de 3 o menos. */
const tolerancia = (p) => (p.length <= 3 ? 0 : p.length <= 5 ? 1 : p.length <= 9 ? 2 : 3);

function palabrasDe(q) {
  return sinTildes(q).split(/[^A-Z0-9]+/).filter((w) => w.length > 1).map((w) => JERGA[w] || w);
}

/* Puntúa cada producto contra lo que escribió el cliente. 0 = no sirve. */
function puntuar(p, palabras) {
  const ref   = sinTildes(p.oem + ' ' + p.sku);
  const marca = sinTildes(p.marca);
  const titulo = sinTildes(p.titulo);
  const autos = sinTildes(p.makes.map((id) => (MARCAS.find((m) => m.id === id) || {}).n || '').join(' '));
  const tipo  = sinTildes(NOMBRE_TIPO[p.tipo] + ' ' + p.tipo);
  const anios = (titulo.match(/(19|20)\d{2}/g) || []);

  let total = 0;
  for (const w of palabras) {
    let mejor = 0;
    if (/^(19|20)\d{2}$/.test(w)) {
      // Un año: vale si cae dentro de un rango del título (2011-2019)
      const y = Number(w);
      const rangos = titulo.match(/((?:19|20)\d{2})\s*[-–]\s*((?:19|20)\d{2})/g) || [];
      const dentro = rangos.some((r) => { const [a, b] = r.split(/[-–]/).map(Number); return y >= a && y <= b; });
      mejor = dentro || anios.includes(w) ? 55 : 0;
    }
    else if (ref.includes(w))                    mejor = 100;   // la referencia manda
    else if (marca.includes(w))                  mejor = 45;
    else if (autos.includes(w))                  mejor = 40;
    else if (tipo.includes(w))                   mejor = 38;
    else if (titulo.includes(w))                 mejor = 30;
    else {
      // nada literal: se prueba con tolerancia a errores de dedo
      const campos = (titulo + ' ' + tipo + ' ' + autos + ' ' + marca).split(/[^A-Z0-9]+/);
      if (campos.some((c) => pareceA(c, w, tolerancia(w)))) mejor = 18;
    }
    if (!mejor) return 0;      // si una palabra no aparece de ninguna forma, no sirve
    total += mejor;
  }
  return total;
}

function buscarInteligente(q, limite) {
  const pal = palabrasDe(q);
  if (!pal.length) return [];
  return CATALOGO
    .map((p) => ({ p, s: puntuar(p, pal) }))
    .filter((x) => x.s > 0)
    .sort((a, b) => b.s - a.s || a.p.precio - b.p.precio)
    .slice(0, limite || 40)
    .map((x) => x.p);
}

/* ---------- Sugerencias mientras escribe ---------- */
function initSugerencias() {
  const campo = $('#omni');
  if (!campo) return;
  const caja = document.createElement('div');
  caja.className = 'sugerencias';
  caja.setAttribute('role', 'listbox');
  campo.closest('.campo-omni').appendChild(caja);

  let temporizador, activo = -1, lista = [];

  const cerrar = () => { caja.classList.remove('abierta'); activo = -1; };
  const pintar = () => {
    if (!lista.length) { cerrar(); return; }
    caja.innerHTML = lista.map((p, i) =>
      '<button type="button" class="sug' + (i === activo ? ' activa' : '') + '" data-sku="' + p.sku + '">' +
      (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '<span class="sug-sinfoto"></span>') +
      '<span class="sug-info"><span class="sug-t">' + p.titulo + '</span>' +
      '<span class="sug-m">' + p.marca + (p.oem ? ' · ' + p.oem : '') + '</span></span>' +
      '<span class="sug-p">' + p.precioFmt + '</span></button>').join('');
    caja.classList.add('abierta');
  };

  campo.addEventListener('input', () => {
    clearTimeout(temporizador);
    const q = campo.value.trim();
    if (q.length < 2) { cerrar(); return; }
    temporizador = setTimeout(() => {
      lista = buscarInteligente(q, 6);
      activo = -1;
      pintar();
    }, 140);
  });

  campo.addEventListener('keydown', (e) => {
    if (!caja.classList.contains('abierta')) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); activo = Math.min(activo + 1, lista.length - 1); pintar(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); activo = Math.max(activo - 1, -1); pintar(); }
    else if (e.key === 'Enter' && activo >= 0) { e.preventDefault(); abrirProducto(lista[activo].sku); cerrar(); }
    else if (e.key === 'Escape') cerrar();
  });

  caja.addEventListener('mousedown', (e) => {
    const b = e.target.closest('.sug');
    if (!b) return;
    e.preventDefault();
    abrirProducto(b.dataset.sku);
    cerrar();
  });
  campo.addEventListener('blur', () => setTimeout(cerrar, 120));
}

/* ---------- REJILLA DE MARCAS Y DE PIEZAS ----------
   Los dos atajos de entrada: por carro o por tipo de pieza. El conteo sale
   del catálogo real, así que si mañana cargas 200 productos, se actualiza solo. */
function pintarAtajos() {
  const rm = $('#rejilla-marcas');
  if (rm) {
    rm.innerHTML = MARCAS.filter((m) => m.id !== 'otra').map((m, i) => {
      const n = CATALOGO.filter((p) => p.makes.includes(m.id)).length;
      return '<button class="marca-bloque" data-marca="' + m.id + '" style="--i:' + i + '">' +
        '<span class="marca-nombre">' + m.n + '</span>' +
        '<span class="marca-lineas">' + m.lineas + '</span>' +
        '<span class="marca-n' + (n ? '' : ' vacio') + '">' +
          (n ? n + ' referencia' + (n > 1 ? 's' : '') : 'Por pedido') + '</span>' +
        '<span class="marca-ir" aria-hidden="true">→</span></button>';
    }).join('') +
    '<button class="marca-bloque marca-otra" data-marca="otra" style="--i:11">' +
      '<span class="marca-nombre">¿Otra marca?</span>' +
      '<span class="marca-lineas">La conseguimos igual</span>' +
      '<span class="marca-n">Escríbenos</span>' +
      '<span class="marca-ir" aria-hidden="true">→</span></button>';

    $$('#rejilla-marcas .marca-bloque').forEach((b) => b.addEventListener('click', () => {
      irACarril('vehiculo');
      const chip = $('#chips-marca .chip[data-marca="' + b.dataset.marca + '"]');
      if (chip) chip.click();
      $('#consola').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
  }

  const rp = $('#rejilla-piezas');
  if (rp) {
    const tipos = [...new Set(CATALOGO.map((p) => p.tipo))]
      .map((t) => ({ t, n: CATALOGO.filter((p) => p.tipo === t).length }))
      .sort((a, b) => b.n - a.n);
    rp.innerHTML = tipos.map((x, i) =>
      '<button class="pieza-bloque" data-tipo="' + x.t + '" style="--i:' + i + '">' +
      '<span class="pieza-nombre">' + NOMBRE_TIPO[x.t] + '</span>' +
      '<span class="pieza-n">' + x.n + '</span></button>').join('');
    $$('#rejilla-piezas .pieza-bloque').forEach((b) => b.addEventListener('click', () => {
      irACarril('vehiculo');
      S.marca = null; S.pieza = NOMBRE_TIPO[b.dataset.tipo];
      pintarResultados(buscarPorTipo(b.dataset.tipo, null), msgTextoLibre(NOMBRE_TIPO[b.dataset.tipo]));
      $('#consola').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
  }
}


/* ---------- CAMPAÑA: cuenta regresiva y cupón ---------- */
function initCampana() {
  const reloj = $('.reloj');
  if (reloj) {
    const fin = new Date(reloj.dataset.termina.replace(' ', 'T') + ':00').getTime();
    const cel = {};
    ['d', 'h', 'm', 's'].forEach((u) => { cel[u] = reloj.querySelector('[data-u="' + u + '"]'); });
    const dos = (n) => String(Math.max(0, n)).padStart(2, '0');
    const tic = () => {
      const falta = fin - Date.now();
      if (falta <= 0) { reloj.classList.add('terminado'); cel.d.textContent = '00'; return; }
      const seg = Math.floor(falta / 1000);
      const v = { d: Math.floor(seg / 86400), h: Math.floor(seg / 3600) % 24,
                  m: Math.floor(seg / 60) % 60, s: seg % 60 };
      Object.keys(v).forEach((u) => {
        const t = dos(v[u]);
        if (cel[u].textContent !== t) {
          cel[u].textContent = t;
          cel[u].classList.remove('gira'); void cel[u].offsetWidth; cel[u].classList.add('gira');
        }
      });
    };
    tic(); setInterval(tic, 1000);
  }

  const cupon = $('.cupon');
  if (cupon) cupon.addEventListener('click', () => {
    const c = cupon.dataset.cupon;
    const fin = () => {
      cupon.classList.add('copiado');
      cupon.querySelector('.cupon-copiar').textContent = '¡Copiado!';
      setTimeout(() => { cupon.classList.remove('copiado');
        cupon.querySelector('.cupon-copiar').textContent = 'Copiar'; }, 2200);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(c).then(fin).catch(fin); else fin();
  });

  // La cifra del descuento sube al entrar en pantalla
  const cifra = $('.campana-cifra');
  if (cifra && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const fin = Number(e.target.dataset.contar), t0 = performance.now();
      const paso = (t) => {
        const k = Math.min(1, (t - t0) / 900);
        e.target.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    }), { threshold: 0.5 });
    io.observe(cifra);
  }
}




/* El asesor saluda.
   Antes borraba la frase letra por letra y el globo quedaba vacío: eso se
   veía como si se interrumpiera. Ahora la frase se desvanece completa y entra
   la siguiente, sin dejar nunca el globo en blanco. */
function initSaludo() {
  const globo = $('#globo');
  if (!globo) return;
  const txt = globo.querySelector('.globo-txt');
  const FRASES = [
    '¡Hola! Soy Camilo.',
    '¿En qué le puedo colaborar?',
    'Busca aquí lo que necesites.',
    'Cuéntame qué le pasa a tu carro.',
  ];

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    txt.textContent = 'Busca aquí lo que necesites.';
    globo.classList.add('visible');
    return;
  }

  let i = 0;

  const escribir = (frase, listo) => {
    txt.textContent = '';
    globo.classList.remove('saliendo');
    let j = 0;
    const tecla = () => {
      txt.textContent = frase.slice(0, ++j);
      if (j < frase.length) return setTimeout(tecla, 40);
      setTimeout(listo, 3200);            // la frase se queda a la vista
    };
    tecla();
  };

  const siguiente = () => {
    globo.classList.add('saliendo');       // se desvanece entera, no letra a letra
    setTimeout(() => {
      i = (i + 1) % FRASES.length;
      escribir(FRASES[i], siguiente);
    }, 420);
  };

  setTimeout(() => { globo.classList.add('visible'); escribir(FRASES[0], siguiente); }, 800);
}

/* ============================================================
   ASESOR TÉCNICO — de un síntoma a una pieza
   El conocimiento va codificado aquí: no consulta un modelo de lenguaje.
   Funciona sin internet, responde al instante y no cuesta por consulta.
   Cada respuesta termina en WhatsApp con el diagnóstico ya escrito.
   ============================================================ */

/* Síntomas en el idioma en que la gente los cuenta, no en manual de taller. */
const SINTOMAS = [
  { c: ['TIC','TICTIC','TIQUETEO','GOLPETEO','CASCABEL','PICA','PICADO','CASCABELEO'],
    t: 'Knock', d: 'Un golpeteo metálico bajo carga suele ser detonación: la mezcla se enciende antes de tiempo.',
    r: 'Casi siempre es el sensor de detonación o una bujía en mal estado. Revisa primero el sensor.' },
  { c: ['APAGA','SEAPAGA','FRIO','ENFRIO','ARRANCA','NOARRANCA','SEVARALENTI','RALENTI'],
    t: 'CKP', d: 'Que se apague sin aviso o no arranque en frío apunta al sensor de cigüeñal.',
    r: 'El CKP le dice a la computadora dónde está el motor. Cuando falla por calor, el carro se apaga y arranca de nuevo al enfriarse.' },
  { c: ['JALONEA','TIRONES','TIRONEA','ACELERA','PIERDEFUERZA','SINFUERZA','FLOJO','DESACELERA'],
    t: 'MAF', d: 'Tirones al acelerar y pérdida de fuerza suelen venir del medidor de aire.',
    r: 'Si el MAF lee mal, la computadora inyecta de más o de menos. Antes de cambiarlo, límpialo: a veces basta.' },
  { c: ['GASTAMUCHO','GASOLINA','CONSUMO','GASTA','COMBUSTIBLE','RINDE','HUMONEGRO'],
    t: 'O2', d: 'Consumo alto o humo negro casi siempre es el sensor de oxígeno cansado.',
    r: 'Un O2 viejo reporta mezcla pobre y la computadora compensa con más gasolina. Es la falla más común pasados los 100.000 km.' },
  { c: ['CALIENTA','SOBRECALIENTA','TEMPERATURA','VENTILADOR','AGUJA','HIERVE','REFRIGERANTE'],
    t: 'ECT', d: 'Problemas de temperatura o de ventilador empiezan por el sensor de refrigerante.',
    r: 'Si el ECT lee mal, el ventilador no prende cuando debe. Es una pieza barata que evita un daño caro.' },
  { c: ['CHECKENGINE','CHECK','TESTIGO','LUZAMARILLA','LUZMOTOR','MOTORPRENDIDO'],
    t: null, d: 'El check engine es un aviso, no un diagnóstico: el carro guardó un código.',
    r: 'Pásale el escáner y dinos el código (empieza por P). Con ese número te decimos exactamente qué pieza es.' },
  { c: ['VIBRA','VIBRACION','TIEMBLA','BRINCA','FALLA','CABECEA'],
    t: 'CMP', d: 'Vibración o cabeceo en marcha puede ser sincronización de árbol de levas.',
    r: 'El CMP y el CKP trabajan juntos. Si uno se desfasa, el motor cabecea. Conviene revisar ambos.' },
  { c: ['ACEITE','FUGA','TESTIGOACEITE','PRESION'],
    t: null, d: 'El testigo de aceite puede ser presión real o el sensor que la mide.',
    r: 'Antes de abrir motor, descarta el sensor de presión: falla más seguido de lo que se cree.' },
  { c: ['NOPRENDE','NOENCIENDE','NADA','MUERTO','BATERIA','ELECTRICO','LUCES'],
    t: 'Módulo', d: 'Fallas eléctricas generales suelen venir del módulo de distribución.',
    r: 'En Ford, Dodge y RAM el TIPM o el BCM son los responsables típicos. Escríbenos con el VIN.' },
];

const norm2 = (t) => sinTildes(t).replace(/[^A-Z0-9]/g, '');

function diagnosticar(txt) {
  const q = (txt || '').trim();
  if (!q) return null;

  // 1) ¿Es un código de escáner?
  const cod = (sinTildes(q).match(/\b[PBCU]\s?0?\d{3,4}\b/) || [])[0];
  if (cod) {
    const limpio = cod.replace(/\s/g, '').toUpperCase();
    const d = DTC[limpio];
    if (d) return { tipo: 'codigo', codigo: limpio, que: d.d, pieza: d.t,
                    consejo: 'Este código apunta directo a esa pieza. Verifica el conector y el arnés antes de cambiarla.' };
    return { tipo: 'codigo', codigo: limpio, que: 'No tenemos ese código en la lista, pero sí lo interpretamos contigo.',
             pieza: null, consejo: 'Mándanos el código y el VIN por WhatsApp y te decimos qué pieza es.' };
  }

  // 2) ¿Describe un síntoma?
  const plano = norm2(q);
  let mejor = null, puntos = 0;
  for (const s of SINTOMAS) {
    const n = s.c.filter((k) => plano.includes(k)).length;
    if (n > puntos) { puntos = n; mejor = s; }
  }
  if (mejor) return { tipo: 'sintoma', que: mejor.d, pieza: mejor.t, consejo: mejor.r };

  // 3) Ni código ni síntoma reconocido
  return { tipo: 'abierto', que: 'No reconocí la falla por el texto, pero un asesor sí puede leerla.',
           pieza: null, consejo: 'Cuéntanos qué carro es, qué hace y cuándo lo hace. Si tienes el código del escáner, mejor.' };
}

function msgDiagnostico(q, dx) {
  return ['*NEXORA · Diagnóstico*', 'Ref: ' + ref(), '',
    '*Lo que le pasa a mi carro:* ' + q,
    dx.codigo ? '*Código:* ' + dx.codigo : '',
    dx.pieza ? '*Pieza probable:* ' + NOMBRE_TIPO[dx.pieza] : '',
    '', '¿Me confirman qué pieza necesito y el precio?',
    '', 'Origen: nexoraoem.com · Asesor técnico'].filter(Boolean).join('\n');
}

function initAsesor() {
  const campo = $('#dx-input'), boton = $('#dx-btn'), salida = $('#dx-salida'), ejemplos = $('#dx-ejemplos');
  if (!campo) return;

  const SUGERENCIAS = ['P0135', 'Se apaga en frío', 'Suena un tic tic', 'Gasta mucha gasolina',
                       'Check engine prendido', 'Jalonea al acelerar', 'Se calienta'];
  if (ejemplos) {
    ejemplos.innerHTML = '<span class="dx-etq">Prueba con:</span>' +
      SUGERENCIAS.map((x) => '<button type="button" class="dx-chip">' + x + '</button>').join('');
    $$('#dx-ejemplos .dx-chip').forEach((b) => b.addEventListener('click', () => {
      campo.value = b.textContent; correr();
    }));
  }

  function correr() {
    const q = campo.value.trim();
    const dx = diagnosticar(q);
    if (!dx) { salida.innerHTML = ''; return; }

    const piezas = dx.pieza ? buscarPorTipo(dx.pieza, null).slice(0, 3) : [];
    salida.innerHTML =
      '<div class="dx-tarjeta">' +
        (dx.codigo ? '<span class="dx-codigo">' + dx.codigo + '</span>' : '') +
        '<p class="dx-que">' + dx.que + '</p>' +
        (dx.pieza ? '<div class="dx-pieza"><span class="micro">Pieza probable</span>' +
                    '<strong>' + NOMBRE_TIPO[dx.pieza] + '</strong></div>' : '') +
        '<p class="dx-consejo">' + dx.consejo + '</p>' +
        (piezas.length
          ? '<div class="dx-lista">' + piezas.map((p) =>
              '<a class="res-item" href="#" data-sku="' + p.sku + '">' +
              (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="56" height="56">'
                     : '<span class="sug-sinfoto"></span>') +
              '<span class="res-info"><span class="res-titulo">' + p.titulo + '</span>' +
              '<span class="res-meta">' + p.marca + (p.oem ? ' · ' + p.oem : '') + '</span></span>' +
              '<span class="res-precio">' + p.precioFmt + '</span></a>').join('') + '</div>'
          : '') +
        '<a class="btn btn-wa btn-bloque mt-m" target="_blank" rel="noopener" href="' +
          waLink(msgDiagnostico(q, dx)) + '">Que lo revise un asesor por WhatsApp</a>' +
      '</div>';
    salida.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  boton.addEventListener('click', correr);
  campo.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); correr(); } });
}

/* ---------- BARRA DE AVANCE ----------
   La página es larga a propósito, pero sin una referencia el visitante no
   sabe cuánto le falta y siente que no termina nunca. Esta barra se lo dice. */
function initAvance() {
  const barra = document.createElement('div');
  barra.className = 'avance';
  barra.innerHTML = '<span class="avance-relleno"></span>';
  document.body.appendChild(barra);
  const relleno = barra.firstElementChild;
  let pedido = false;
  const pintar = () => {
    pedido = false;
    const alto = document.documentElement.scrollHeight - innerHeight;
    const k = alto > 0 ? Math.min(1, scrollY / alto) : 0;
    relleno.style.transform = 'scaleX(' + k.toFixed(4) + ')';
    barra.classList.toggle('visible', scrollY > 120);
  };
  addEventListener('scroll', () => {
    if (!pedido) { pedido = true; requestAnimationFrame(pintar); }
  }, { passive: true });
  pintar();
}

/* ---------- VOLVER AL INICIO ----------
   Siempre a un clic, en celular y en escritorio. Aparece al bajar. */
function initVolverArriba() {
  const b = document.createElement('button');
  b.className = 'volver-arriba';
  b.type = 'button';
  b.setAttribute('aria-label', 'Volver al inicio');
  b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">' +
    '<path d="M12 19V6M6 11.5 12 5.5l6 6" fill="none" stroke="currentColor" ' +
    'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '<span class="txt">Inicio</span>';
  document.body.appendChild(b);
  b.addEventListener('click', () => {
    const reducido = matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reducido ? 'auto' : 'smooth' });
    const o = $('#omni'); if (o) setTimeout(() => o.focus(), reducido ? 0 : 600);
  });
  addEventListener('scroll', () => {
    b.classList.toggle('visible', scrollY > 620);
  }, { passive: true });
}

/* ---------- SECUENCIA DE ENCENDIDO ----------
   El titular se arma palabra por palabra y el campo de búsqueda escribe
   solo ejemplos reales: enseña qué se puede buscar sin decir una instrucción.
   ============================================================ */
function armarTitular() {
  const h = $('.hero-titular');
  if (!h) return;
  let i = 0;
  const partes = h.innerHTML.split(/(<br\s*\/?>)/i);
  h.innerHTML = partes.map((parte) => {
    if (/^<br/i.test(parte)) return parte;
    return parte.split(/\s+/).filter(Boolean).map((w) =>
      '<span class="palabra"><span style="--i:' + (i++) + '">' + w + '</span></span>').join(' ');
  }).join('');
}

const EJEMPLOS = [
  '3FADP4BJ0EM102345',
  'P0135',
  '0258006858',
  'Ford Fiesta 2014',
  'sensor de oxígeno Mazda 3',
  '234-4209',
];

function escribirEjemplos() {
  const campo = $('#omni');
  if (!campo) return;
  const envoltura = campo.closest('.campo-omni');
  const original = campo.placeholder;
  let iEj = 0, iCar = 0, borrando = false, detenido = false, temporizador;

  const detener = () => {
    if (detenido) return;
    detenido = true;
    clearTimeout(temporizador);
    campo.placeholder = original;
    envoltura.classList.remove('escribiendo');
  };
  campo.addEventListener('focus', detener);
  campo.addEventListener('input', detener);

  const paso = () => {
    if (detenido) return;
    const texto = EJEMPLOS[iEj];
    envoltura.classList.add('escribiendo');
    if (!borrando) {
      iCar++;
      campo.placeholder = texto.slice(0, iCar);
      if (iCar === texto.length) { borrando = true; temporizador = setTimeout(paso, 1900); return; }
      temporizador = setTimeout(paso, 55);
    } else {
      iCar--;
      campo.placeholder = texto.slice(0, iCar);
      if (iCar === 0) { borrando = false; iEj = (iEj + 1) % EJEMPLOS.length; temporizador = setTimeout(paso, 380); return; }
      temporizador = setTimeout(paso, 26);
    }
  };
  temporizador = setTimeout(paso, 2100);
}

/* ---------- MOCIÓN ---------- */
function initMovimiento() {
  const reducido = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducido) { armarTitular(); escribirEjemplos(); }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach((el) => io.observe(el));

  const ioN = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      ioN.unobserve(e.target);
      const destino = e.target.textContent.trim();
      const m = destino.match(/^(\d+)/);
      if (!m) return;
      const fin = Number(m[1]), resto = destino.slice(m[1].length);
      const dur = 900, t0 = performance.now();
      const paso = (t) => {
        const k = Math.min(1, (t - t0) / dur);
        e.target.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3))) + resto;
        if (k < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.6 });
  if (!reducido) $$('.canal .valor').forEach((el) => ioN.observe(el));

  const ioH = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('trazado'); ioH.unobserve(e.target); } });
  }, { threshold: 0.25 });
  $$('.protocolo').forEach((el) => ioH.observe(el));

  const hero = $('.consola-hero');
  if (hero && !reducido && matchMedia('(pointer:fine)').matches) {
    hero.addEventListener('pointermove', (ev) => {
      const r = hero.getBoundingClientRect();
      const px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
      hero.style.setProperty('--rx', ((px - 0.5) * -16).toFixed(1) + 'px');
      hero.style.setProperty('--ry', ((py - 0.5) * -10).toFixed(1) + 'px');
      hero.style.setProperty('--mx', (px * 100).toFixed(1) + '%');   // el resplandor sigue al cursor
      hero.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    }, { passive: true });
    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--rx', '0px'); hero.style.setProperty('--ry', '0px');
      hero.style.setProperty('--mx', '26%'); hero.style.setProperty('--my', '42%');
    });
  }

  const ioR = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('encendida'); ioR.unobserve(e.target); } });
  }, { threshold: 0.9 });
  $$('.nx-regla').forEach((el) => ioR.observe(el));

  /* Cada módulo enciende su borde superior al entrar en pantalla */
  if (!reducido) {
    const ioE = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('enciende'); ioE.unobserve(e.target); } });
    }, { threshold: 0.3 });
    $$('.marca-bloque, .promo, .promesa, .ficha-id, .pieza-bloque').forEach((el) => ioE.observe(el));
  }

  const h = $('.header');
  if (h) {
    let last = 0;
    addEventListener('scroll', () => {
      const y = scrollY;
      h.classList.toggle('oculto', y > last && y > 160);
      last = y;
      const wa = $('#wa-flotante');
      if (wa) wa.classList.toggle('visible', y > 500);
    }, { passive: true });
  }
}

/* ---------- ARRANQUE ---------- */
document.addEventListener('DOMContentLoaded', () => {
  const wa = $('#wa-flotante');
  if (wa) wa.href = waLink('*NEXORA*\nHola, necesito ayuda para encontrar un repuesto.\n\nOrigen: nexoraoem.com');
  $$('[data-wa]').forEach((a) => { a.href = waLink(decodeURIComponent(a.dataset.wa)); });
  $$('[data-abrir-consola]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    const c = $('#consola');
    if (c) { c.scrollIntoView({ behavior: 'smooth', block: 'center' }); const o = $('#omni'); if (o) o.focus(); }
    else window.location = RUTAS.root;
  }));

  const bc = $('#btn-carrito');
  if (bc) bc.addEventListener('click', (e) => { e.preventDefault(); abrirCarrito(); });
  const velo = $('#velo'); if (velo) velo.addEventListener('click', () => cerrarPanel());
  $$('[data-cerrar-panel]').forEach((b) => b.addEventListener('click', () => cerrarPanel()));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cerrarPanel(); });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-sku]');
    if (!t) return;
    e.preventDefault();
    abrirProducto(t.dataset.sku);
  });

  initConsola();
  initSugerencias();
  pintarAtajos();
  initCampana();
  initAsesor();
  initSaludo();
  initAvance();
  initVolverArriba();
  initMovimiento();
  leerCarrito().then((c) => pintarCuenta(c.item_count)).catch(() => {});
});
